var _defs, _rect, _polygon, _defs2, _rect2, _polygon2, _defs3, _clipPath, _path, _path2, _defs4, _clipPath2, _rect3, _defs5, _clipPath3, _rect4, _defs6, _clipPath4, _circle, _defs7, _clipPath5, _rect5, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 140 140",
    id: "Layer_17",
    viewBox: "0 0 140 140",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 97.071106,
    id: "Adobe_OpacityMaskFilter",
    width: 97.0710449,
    x: 42.9289551,
    y: 42.928894
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    height: 97.071106,
    id: "SVGID_1_",
    maskUnits: "userSpaceOnUse",
    width: 97.0710449,
    x: 42.9289551,
    y: 42.928894
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 70,
    cy: 70,
    gradientTransform: "matrix(0.7071068 0.7071068 -0.2721382 0.2721382 39.5522003 1.4528493)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_",
    r: 106.5634918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#SVGID_2_)",
    height: 140,
    width: 140
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_3_",
    x1: 69.9999847,
    x2: 140.0000153,
    y1: 69.9999542,
    y2: 139.9999847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_3_)",
    mask: "url(#SVGID_1_)",
    points: "140,85.8580933    97.0710449,42.928894 42.9289551,97.0710449 85.8580933,140 140,140  "
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 97.071106,
    id: "Adobe_OpacityMaskFilter_1_",
    width: 97.0710449,
    x: 42.9289551,
    y: 42.928894
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    height: 97.071106,
    id: "SVGID_4_",
    maskUnits: "userSpaceOnUse",
    width: 97.0710449,
    x: 42.9289551,
    y: 42.928894
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter_1_)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 70,
    cy: 70,
    gradientTransform: "matrix(0.7071068 0.7071068 -0.3889087 0.3889087 47.7261353 -6.7210855)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_5_",
    r: 79.5565872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#SVGID_5_)",
    height: 140,
    width: 140
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_6_",
    x1: 69.9999847,
    x2: 140.0000153,
    y1: 69.9999542,
    y2: 139.9999847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF543E",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FF543E",
      stopOpacity: 0
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_6_)",
    mask: "url(#SVGID_4_)",
    points: "140,85.8580933    97.0710449,42.928894 42.9289551,97.0710449 85.8580933,140 140,140  "
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M90,100H50c-5.5228462,0-10-4.47715-10-10V50c0-5.5228462,4.4771538-10,10-10h40     c5.52285,0,10,4.4771538,10,10v40C100,95.52285,95.52285,100,90,100z",
    id: "SVGID_61_"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_61_"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_8_)"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    cx: -318.6435242,
    cy: -179.4550629,
    gradientTransform: "matrix(0 -1.98198 -1.8439 0 -275.8970947 -524.6257935)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_9_",
    r: 31.9939842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDD55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#FFDD55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FF543E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C837AB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.0104446,38.0087242c-13.3597031,0-17.2669067,0.0137787-18.0263939,0.0767822     c-2.7416382,0.2278976-4.4476547,0.6595688-6.3062592,1.5849342c-1.4323463,0.7112503-2.5619812,1.5357132-3.6768494,2.691433     c-2.0303879,2.107666-3.2609253,4.7006531-3.7063789,7.7829056c-0.2165756,1.4963341-0.2795792,1.801506-0.2923775,9.4446259     c-0.004921,2.5477028,0,5.9006767,0,10.3980446c0,13.348877,0.0147667,17.2521362,0.0787544,18.0101547     c0.2215004,2.6678085,0.6398811,4.3462601,1.5258675,6.1822205c1.693222,3.5144196,4.9270744,6.1526871,8.7368202,7.1371231     c1.3191376,0.3396301,2.7760925,0.5266724,4.6465111,0.6152649c0.7924652,0.034462,8.8697166,0.0590668,16.9518929,0.0590668     s16.1643448-0.0098495,16.9371185-0.0492249c2.1657486-0.1018906,3.4233551-0.2707214,4.8138657-0.6300354     c3.8343506-0.989357,7.00914-3.5882492,8.7368164-7.151886c0.8687592-1.7916641,1.3092957-3.5341034,1.5086441-6.0626144     C101.9817886,87.5462341,102,78.756752,102,69.9790802c0-8.7791481-0.0196838-17.5523949-0.0630035-18.103672     c-0.2018127-2.5693626-0.6423416-4.297039-1.5391617-6.1231575c-0.7358627-1.4948578-1.5529327-2.6112022-2.7391739-3.7526474     c-2.117012-2.0220184-4.7060623-3.2525597-7.7912674-3.6975212c-1.4948578-0.2160835-1.7926483-0.2800713-9.4416733-0.2933578     H70.0104446z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 62.7168579,
    cy: 269.4156799,
    gradientTransform: "matrix(0.17394 0.86872 3.5818 -0.71718 -948.6223145 181.3540497)",
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_11_",
    r: 31.9939842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3771C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    style: {
      stopColor: "#3771C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6600FF",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0104446,38.0087242c-13.3597031,0-17.2669067,0.0137787-18.0263939,0.0767822     c-2.7416382,0.2278976-4.4476547,0.6595688-6.3062592,1.5849342c-1.4323463,0.7112503-2.5619812,1.5357132-3.6768494,2.691433     c-2.0303879,2.107666-3.2609253,4.7006531-3.7063789,7.7829056c-0.2165756,1.4963341-0.2795792,1.801506-0.2923775,9.4446259     c-0.004921,2.5477028,0,5.9006767,0,10.3980446c0,13.348877,0.0147667,17.2521362,0.0787544,18.0101547     c0.2215004,2.6678085,0.6398811,4.3462601,1.5258675,6.1822205c1.693222,3.5144196,4.9270744,6.1526871,8.7368202,7.1371231     c1.3191376,0.3396301,2.7760925,0.5266724,4.6465111,0.6152649c0.7924652,0.034462,8.8697166,0.0590668,16.9518929,0.0590668     s16.1643448-0.0098495,16.9371185-0.0492249c2.1657486-0.1018906,3.4233551-0.2707214,4.8138657-0.6300354     c3.8343506-0.989357,7.00914-3.5882492,8.7368164-7.151886c0.8687592-1.7916641,1.3092957-3.5341034,1.5086441-6.0626144     C101.9817886,87.5462341,102,78.756752,102,69.9790802c0-8.7791481-0.0196838-17.5523949-0.0630035-18.103672     c-0.2018127-2.5693626-0.6423416-4.297039-1.5391617-6.1231575c-0.7358627-1.4948578-1.5529327-2.6112022-2.7391739-3.7526474     c-2.117012-2.0220184-4.7060623-3.2525597-7.7912674-3.6975212c-1.4948578-0.2160835-1.7926483-0.2800713-9.4416733-0.2933578     H70.0104446z",
    fill: "url(#SVGID_11_)"
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M90,41c4.9626236,0,9,4.0373802,9,9v40c0,4.9626236-4.0373764,9-9,9H50c-4.9626198,0-9-4.0373764-9-9V50     c0-4.9626198,4.0373802-9,9-9H90 M90,40H50c-5.52285,0-10,4.47715-10,10v40c0,5.52285,4.47715,10,10,10h40     c5.52285,0,10-4.47715,10-10V50C100,44.47715,95.52285,40,90,40L90,40z",
    id: "SVGID_65_"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_65_"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_14_",
    x1: 20,
    x2: 120,
    y1: 20,
    y2: 120
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    clipPath: "url(#SVGID_12_)",
    fill: "url(#SVGID_14_)",
    height: 100,
    width: 100,
    x: 20,
    y: 20
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M90,41c4.9626236,0,9,4.0373802,9,9v40c0,4.9626236-4.0373764,9-9,9H50c-4.9626198,0-9-4.0373764-9-9V50     c0-4.9626198,4.0373802-9,9-9H90 M90,40H50c-5.52285,0-10,4.47715-10,10v40c0,5.52285,4.47715,10,10,10h40     c5.52285,0,10-4.47715,10-10V50C100,44.47715,95.52285,40,90,40L90,40z",
    id: "SVGID_68_"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_68_"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_17_",
    x1: 20,
    x2: 120,
    y1: 20,
    y2: 120
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    clipPath: "url(#SVGID_15_)",
    fill: "url(#SVGID_17_)",
    height: 100,
    width: 100,
    x: 20,
    y: 20
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,99c-4.9624023,0-9-4.0375977-9-9V50c0-4.9624023,4.0375977-9,9-9h40c4.9624023,0,9,4.0375977,9,9v40     c0,4.9624023-4.0375977,9-9,9H50z",
    id: "SVGID_71_"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_71_"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 45,
    cy: 45,
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_19_",
    r: 45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_18_)",
    cx: 45,
    cy: 45,
    fill: "url(#SVGID_19_)",
    r: 45
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M90,99.1499023H50c-5.0454102,0-9.1499023-4.1044922-9.1499023-9.1499023V50     c0-5.0454102,4.1044922-9.1499023,9.1499023-9.1499023h40c5.0454102,0,9.1499023,4.1044922,9.1499023,9.1499023v40     C99.1499023,95.0454102,95.0454102,99.1499023,90,99.1499023z M50,41.1499023     c-4.8798828,0-8.8500977,3.9702148-8.8500977,8.8500977v40c0,4.8798828,3.9702148,8.8500977,8.8500977,8.8500977h40     c4.8798828,0,8.8500977-3.9702148,8.8500977-8.8500977V50c0-4.8798828-3.9702148-8.8500977-8.8500977-8.8500977H50z",
    id: "SVGID_74_"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#SVGID_74_"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_21_",
    x1: 20,
    x2: 120,
    y1: 20,
    y2: 120
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    clipPath: "url(#SVGID_20_)",
    fill: "url(#SVGID_21_)",
    height: 100,
    width: 100,
    x: 20,
    y: 20
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6416626,53.3560791L58.125,51.7916679l-6.5,5.5416641   l1.7316895,29.3085136L66.7148438,100H90c5.5228271,0,10-4.4771729,10-10V66.7144775L86.6416626,53.3560791z",
    opacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8791504,61.7532539c-0.0999985-2.1292076-0.4375-3.5825462-0.9291687-4.854229   c-0.5124969-1.3154221-1.1958466-2.431282-2.3083496-3.5429459c-1.1125259-1.1125069-2.225029-1.7958527-3.5417023-2.3062897   c-1.2750092-0.4945679-2.7292175-0.8316612-4.8583984-0.9291687c-2.1329193-0.0970459-2.8123474-0.1208229-8.242775-0.1208229   c-5.4287796,0-6.1107254,0.023777-8.2436485,0.1208229c-2.1291809,0.0975075-3.5825195,0.4346008-4.8541985,0.9291687   c-1.3154488,0.5108452-2.4312859,1.194191-3.5429497,2.3062897c-1.1125298,1.1116638-1.7958527,2.2275238-2.3083725,3.5425415   c-0.495842,1.2720871-0.8333435,2.7258568-0.9291687,4.8541985C50.0249977,63.8861732,50,64.5682755,50,70   s0.0241585,6.1113052,0.1208267,8.2446594c0.0979347,2.1291809,0.4350052,3.58255,0.9291916,4.8542252   c0.5112495,1.3154297,1.1945992,2.4312592,2.306694,3.5429535c1.1112595,1.1125031,2.2270966,1.7975006,3.5417023,2.3083496   c1.2724953,0.4945908,2.726265,0.8316879,4.8550415,0.9291916c2.1333542,0.0970688,2.8146133,0.1208267,8.2459106,0.1208267   c5.4321594,0,6.1117401-0.0237579,8.2450943-0.1208267c2.1291809-0.0975037,3.584198-0.4346008,4.8567123-0.9291916   c1.3150177-0.510849,2.4291992-1.1958466,3.5404587-2.3083496c1.1125031-1.1116943,1.7958527-2.2275238,2.3083496-3.5425415   c0.4916687-1.2720871,0.8291702-2.7258606,0.9291687-4.8542252C89.9749985,76.1117172,90,75.4317245,90,70   S89.9749985,63.8866043,89.8791504,61.7532539z M86.2807846,78.0746536   c-0.0891647,1.9500122-0.4149933,3.0083771-0.6887665,3.7125473c-0.3624954,0.933342-0.796669,1.5979233-1.4966736,2.2975159   c-0.6999969,0.7000046-1.3646011,1.1333618-2.2983475,1.4958572c-0.7041779,0.2749939-1.7633514,0.6000137-3.7133713,0.6891708   c-2.1083527,0.0958252-2.7416992,0.1166611-8.0817413,0.1166611c-5.340477,0-5.9733963-0.0208359-8.0817757-0.1166611   c-1.950016-0.0899963-3.0083504-0.4158325-3.7137718-0.6895981c-0.9333382-0.3625031-1.600029-0.7958298-2.3000336-1.4958344   c-0.7000008-0.7000046-1.1333313-1.3650131-1.4966736-2.29879c-0.2737427-0.7041702-0.6000061-1.7625046-0.6887627-3.7125244   c-0.0958252-2.1083527-0.1150017-2.7416992-0.1150017-8.0825882c0-5.3408813,0.0191765-5.9709015,0.1150017-8.0792542   c0.0891647-1.950016,0.41502-3.0083504,0.6887627-3.7133636c0.3625031-0.9333382,0.7966728-1.600029,1.4966736-2.3000336   c0.7000046-0.7000008,1.3666954-1.1333313,2.3000336-1.4966736c0.7050133-0.2749901,1.7637558-0.6000061,3.7137985-0.6896019   c1.8450089-0.083313,2.5600204-0.1083107,6.2875519-0.112484v0.0049858c0.5325089-0.0008125,1.1266632,0,1.7941971,0   c5.3400421,0,5.9729614,0.0191765,8.0817413,0.1150017c1.9500198,0.0891876,3.0083542,0.4150162,3.7133713,0.6887627   c0.9333344,0.3625031,1.5987549,0.7958565,2.2983475,1.4958611c0.7000046,0.7000046,1.1333389,1.3666649,1.4966736,2.3000069   c0.2737732,0.704174,0.6000137,1.7625351,0.6887665,3.7125511c0.0958252,2.1083527,0.116684,2.7416992,0.116684,8.0792542   S86.3766098,75.966301,86.2807846,78.0746536z M70.0014496,59.7290535c0.0000763,0,0.0001526,0,0.0001526,0h0.0002823H70.0014496z    M69.9956284,49.9997978c0.0010681,0,0.0020599,0,0.0031281,0s0.0020599,0,0.0031281,0H69.9956284z M83.0778275,59.3240547   c0,1.3250084-1.0749893,2.4000282-2.4000244,2.4000282c-1.3250122,0-2.4000015-1.0750198-2.4000015-2.4000282   c0-1.3254433,1.0749893-2.399189,2.4000015-2.399189v-0.0008392   C82.0028381,56.9240265,83.0778275,57.9990425,83.0778275,59.3240547z M70.0016785,59.7290535   C64.3296509,59.7291527,59.7309341,64.327919,59.7309341,70c0,5.6721344,4.598793,10.2688599,10.2709503,10.2688599   C75.6740112,80.268837,80.2711487,75.6721344,80.2711487,70C80.2711487,64.327919,75.6737061,59.7291527,70.0016785,59.7290535z    M70.0018845,76.6667328c-3.6821365,0-6.6667366-2.9850311-6.6667366-6.6667328   c0-3.6821365,2.9846001-6.6667328,6.6667366-6.6667328c3.6817017,0,6.6667328,2.9845963,6.6667328,6.6667328   C76.6686172,73.6817017,73.6835861,76.6667328,70.0018845,76.6667328z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3567123,86.6418381c1.1112595,1.1125031,2.2270966,1.7975006,3.5417023,2.3083496   c1.2724953,0.4945908,2.726265,0.8316879,4.8550415,0.9291916c2.1333542,0.0970688,2.8146133,0.1208267,8.2459106,0.1208267   c5.4321594,0,6.1117401-0.0237579,8.2450943-0.1208267c2.1291809-0.0975037,3.584198-0.4346008,4.8567123-0.9291916   c1.3150177-0.510849,2.4291992-1.1958466,3.5404587-2.3083496c1.1125031-1.1116943,1.7958527-2.2275238,2.3083496-3.5425415   c0,0-2.4708176,5.4423676-16.1583176,5.4423676C58.2708321,88.5416641,53.3567123,86.6418381,53.3567123,86.6418381z",
    fill: "#FF543E",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableInstagramIcon);
export default __webpack_public_path__ + "static/media/table_instagram_icon.4db11fa17858f6156c68dcc2e70808e7.svg";
export { ForwardRef as ReactComponent };